export default "<router-outlet><span *ngIf=\"routerLoading\" class=\"page-loader\"></span></router-outlet>"